<template>
  <div>
    <router-view />
  </div>
</template>




<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
